import { getQueryString } from '@sonar-software/sonar-http';
import { SonarObjectTypeId } from '@sonar-software/sonar-ts-types';

export type GetResourceIdsUriOptions = {
	childType: number;
	parentType: number;
	sonarObjectId: number;
};

export function getResourceIdsUri(options: GetResourceIdsUriOptions): string {
	const { childType, parentType, sonarObjectId } = options;
	const tagPrefix = parentType === SonarObjectTypeId.SonarTag ? 'tag-' : '';

	return `v3/core/sonar-objects/${sonarObjectId}/${tagPrefix}children?${getQueryString({
		childSonarObjectType: childType,
		...!tagPrefix && { parentSonarObjectType: parentType }
	})}`;
}

export interface UseBulkSelectWorkflowResult {
	resourceIdsUri: string;
}

export function useBulkSelectWorkflow(options: GetResourceIdsUriOptions): UseBulkSelectWorkflowResult {
	return {
		resourceIdsUri: getResourceIdsUri(options)
	};
}
